// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fUBo","newExpiryDate":"styles_newExpiryDate__2jlcc","footer":"styles_footer__34TUG"};